import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { bemModifier } from 'utils/BEMHelper';

import ShareableReportCard from 'modules/ShareableReport/components/ShareableReportCard/ShareableReportCard';

const ShareableReportDraggableSection = ({
  matches,
  onDragEnd,
  onDragStart,
  onDragUpdate,
  setMappedMatches,
  droppableItemIndex,
}) => (
  <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart} onDragUpdate={onDragUpdate}>
    <Droppable droppableId="droppable" direction="horizontal">
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className="o-draggable-section-table"
        >
          {matches.map((match, index) => (
            <Draggable index={index} key={match.id} draggableId={match.dragId}>
              {(draggableProvided, draggableSnapshot) => {
                const { innerRef, draggableProps, dragHandleProps } = draggableProvided;
                const isDroppable = droppableItemIndex === index;

                const stylesName = classNames(
                  ...bemModifier('o-draggable-section-table__column', {
                    'no-border': matches.length > 5,
                    draggable: draggableSnapshot.isDragging,
                    droppable: isDroppable && snapshot.isDraggingOver,
                  }),
                );

                return (
                  <div
                    ref={innerRef}
                    {...draggableProps}
                    {...dragHandleProps}
                    className={stylesName}
                    style={{ ...draggableProps.style }}
                  >
                    <ShareableReportCard
                      match={match}
                      setMappedMatches={setMappedMatches}
                      draggable={draggableSnapshot.isDragging}
                    />
                  </div>
                );
              }}
            </Draggable>
          ))}
        </div>
      )}
    </Droppable>
  </DragDropContext>
);

ShareableReportDraggableSection.propTypes = {
  matches: PropTypes.array,
  onDragEnd: PropTypes.func,
  onDragStart: PropTypes.func,
  onDragUpdate: PropTypes.func,
  setMappedMatches: PropTypes.func,
  droppableItemIndex: PropTypes.number,
};

export default ShareableReportDraggableSection;
